import React from 'react';
import { Messages, Control, Code, Name, Title, Actions, Form, Files, Toast, Button, API, Utility, useListContext, useCallback, useEffect, useState, Hooks } from 'helpers/ListImports';
import { Stock } from 'models/StockModel';


const StockList: React.FC = () => {
  const width = { sno: 13, type:35, amount: 13,   date: 13, segment:13, createdby: 13 }
  const [formId, formName] = [Code.Form.Id.STOCK, Code.Form.Name.STOCK];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [stockData, setStockData] = useState<Stock[]>([]); 
  const [selectedStock, setselectedStock] = useState<Stock | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const PriClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);

  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.File.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);


  useEffect(() => {
    if(stockData){
      console.log("stockData---->",stockData);
    }
  }, stockData);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Stock.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Stock.Number, 
        Name.Stock.Date, 
        Name.Common.TypeId, 
        Name.Stock.Net,
        Name.Common.SegmentName,
        Name.User.FullName,
      ]),
      ...(!Privilege.ALLLOC && { location_id: locationId }),
      ...(userId != 1 && { user_id: userId }),
    });
    await API.Data.List<Stock>(url, setStockData, setError, setLoading); 
 }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId}  Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Created} value={userId} options={userOptions} onChange={setUserId} />
              <Control.Dropdown title={Title.Status} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, stockData, setSelectAllChecked,formName)} extra={2} />
              <Control.Grid.Items values={[
                [Title.Serial, width.sno], 
                [Title.Type, width.type], 
                [Title.Amount, width.amount, Code.Align.RIGHT],
                [Title.Segment, width.segment],
                [Title.Date, width.date],
                [Title.CreatedBy, width.createdby]
              ]} last={1} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(stockData) && (
              <Control.Grid.Row>
                {stockData.map((stockData) => { return (
                  <Control.Grid.Data<Stock> key={stockData.stock_id} itemKey={stockData.stock_key} data={stockData} setMenuPosition={setMenuPosition} setSelectedData={setselectedStock} setShowMenu={setShowMenu}>
                    <Control.Grid.Check keyId={stockData.stock_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                    <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, stockData.stock_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Print path={Utility.Join.Print(Privilege, formName, stockData.stock_key)} iframeRef={iframeRef} Privilege={Privilege} />
                    <Control.Grid.Items values={[
                      [stockData.stock_number, width.sno],
                      [Utility.Get.FormName(stockData.type_id), width.type],
                      [Utility.Format.Amount(stockData.stock_net_amount), width.amount, Code.Align.RIGHT],
                      [stockData.segment_name, width.segment], 
                      [Utility.Format.DateOnly(stockData.stock_date), width.date], 
                      [Utility.Get.FullName(stockData,Code.Form.Name.USER), width.createdby], 
                    ]} /> 
                    <Control.Grid.Actions>
                      <Control.Action.All formName={formName} activeId={activeId} keyId={stockData.stock_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                    </Control.Grid.Actions>
                  </Control.Grid.Data>)})}
              </Control.Grid.Row>
            )}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={stockData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, `${formName}/${selectedStock?.stock_key}`)} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedStock?.stock_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default StockList;